import { NOT_SET, track } from '@/src/utils/tracking';
import { logError } from '@/src/logger';
import { getScreenName, getSortingSelect } from './utilsTracking';

const shopListUpdated = (
  bannerId,
  bannerName,
  contentIds,
  ncrRequestToken,
  shopGoldVip,
  shopGoldVipPositions,
  shopListBusinessIndex,
  shopListBusinessType,
  origin,
  shopQuantityTotal,
  sortingSelected,
  rankingRequestId,
  landingId,
  landingTitle,
  landingType,
  isItemLanding = false,
) => {
  const EVENT_NAME = 'shop_list.updated';

  const getOriginEvent = () => {
    switch (origin) {
      case 'home':
        return 'home';
      case 'homefood':
        return 'shop_list';
      default:
        return 'home';
    }
  };

  const cleanNcrRequestTokens = () => {
    if (!ncrRequestToken) {
      return NOT_SET;
    }
    const tokens = ncrRequestToken.split(',');
    const filteredTokens = tokens.filter(
      (token) => token.trim().toLowerCase() !== 'null',
    );
    const cleanedNcrRequestToken = filteredTokens.join(',');

    return cleanedNcrRequestToken;
  };

  try {
    const payload = {
      bannerId: bannerId || NOT_SET,
      bannerName: bannerName || NOT_SET,
      action: 'enter_landing',
      content_ids: contentIds || NOT_SET,
      shopGoldVip: shopGoldVip || 0,
      ncrRequestToken: cleanNcrRequestTokens() || NOT_SET,
      shopGoldVipPositions:
        shopGoldVipPositions?.length > 0
          ? shopGoldVipPositions.join(',')
          : NOT_SET,
      shopListBusinessIndex,
      shopListBusinessType: shopListBusinessType || NOT_SET,
      eventOrigin: isItemLanding ? getOriginEvent() : 'global_organic_list',
      shopQuantityTotal: shopQuantityTotal || NOT_SET,
      sortingSelected: getSortingSelect(sortingSelected) || 'recommended',
      screenType: isItemLanding ? 'items_landing' : 'vendors_landing',
      screenName: getScreenName(landingType),
      rankingRequestId,
      landingId,
      landingTitle,
      landingOrigin: getOriginEvent(),
    };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default shopListUpdated;
